import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------hastag-listing--------------------------
export const hastagListApi = async (data) => {
    const endPoint =
        `hastag/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
// ------------------------Add hastag------------------
export const addHastagApi = async (data) => {
    const endPoint = `hastag/add`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit hastag------------------
export const editHastagApi = async (data) => {
    const endPoint = `hastag/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
export const updateStatus = async (data) => {
    const endPoint = `hastag/status`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
// ------------------------- remove Status------------
export const removehastagApi = async (id) => {
    const endPoint = `hastag/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};





